"use client";

// src/utilities/useCMSLink.ts
function useCMSLink(customLocation) {
  function getHrefFromCMSParams(args) {
    var _a;
    const location = customLocation != null ? customLocation : {
      search: typeof window !== "undefined" ? window.location.search : "",
      pathname: typeof window !== "undefined" ? window.location.pathname : ""
    };
    const cmsOrCurrentQuery = (_a = args.query) != null ? _a : location.search;
    const queryString = !cmsOrCurrentQuery ? "" : cmsOrCurrentQuery.startsWith("?") ? cmsOrCurrentQuery : `?${cmsOrCurrentQuery}`;
    if (args.href) {
      return `${args.href}${args.pathname || ""}${args.hash || ""}${queryString}`;
    }
    return `${args.pathname || location.pathname}${args.hash || ""}${queryString}`;
  }
  return { getHrefFromCMSParams };
}

export {
  useCMSLink
};
